module.exports = __webpack_public_path__ + "static/media/KAWS-ngv.4e65bc2b.jpg";